// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2TyCD","emails":"CreateEditClinics_emails__Dqwy2","emailTagLabel":"CreateEditClinics_emailTagLabel__1YuyF"};